import React from 'react';
import keyBy from 'lodash/keyBy';
import {FormattedMessage} from 'react-intl';

const messages = {
  GREATER_THAN: (
    <FormattedMessage
      id="Operand__GreaterThan"
      description="Greater than option for filtering"
      defaultMessage="Greater than"
    />
  ),
  GREAT_THAN_EQUALS_TO: (
    <FormattedMessage
      id="Operand__GreatThanEqualsTo"
      description="Greater than or equal to option for filtering"
      defaultMessage="Greater than or equal to"
    />
  ),
  LESS_THAN: (
    <FormattedMessage
      id="Operand__LessThan"
      description="Less than option for filtering"
      defaultMessage="Less than"
    />
  ),
  LESS_THAN_EQUALS_TO: (
    <FormattedMessage
      id="Operand__LessThanEqualsTo"
      description="Less than or equal to option for filtering"
      defaultMessage="Less than or equal to"
    />
  ),
  EQUALS: (
    <FormattedMessage
      id="Operand__Equals"
      description="Equals option for filtering"
      defaultMessage="Equals"
    />
  ),
  NOT_EQUALS: (
    <FormattedMessage
      id="Operand__NotEquals"
      description="Not equals option for filtering"
      defaultMessage="Not equals"
    />
  ),
  IN: (
    <FormattedMessage
      id="Operand__In"
      description="In operand for filtering strings"
      defaultMessage="In"
    />
  ),
  NOT_IN: (
    <FormattedMessage
      id="Operand__NotIn"
      description="Not in operand for filtering strings"
      defaultMessage="Not in"
    />
  ),
};

export const NUMERIC_OPERANDS = [
  {
    value: 'GREATER_THAN',
    el: messages.GREATER_THAN,
    shorthand: '>',
  },
  {
    value: 'GREAT_THAN_EQUALS_TO',
    el: messages.GREAT_THAN_EQUALS_TO,
    shorthand: '≥',
  },
  {
    value: 'LESS_THAN',
    el: messages.LESS_THAN,
    shorthand: '<',
  },
  {
    value: 'LESS_THAN_EQUALS_TO',
    el: messages.LESS_THAN_EQUALS_TO,
    shorthand: '≤',
  },
  {
    value: 'EQUALS',
    el: messages.EQUALS,
    shorthand: '=',
  },
  {
    value: 'NOT_EQUALS',
    el: messages.NOT_EQUALS,
    shorthand: '≠',
  },
];

export const STRING_OPERANDS = [
  {value: 'IN', el: messages.IN, shorthand: '='},
  {value: 'NOT_IN', el: messages.NOT_IN, shorthand: '≠'},
];

export const OPERANDS_BY_VALUE = keyBy(
  [...STRING_OPERANDS, ...NUMERIC_OPERANDS],
  'value'
);

export const COLUMN_TYPES = {
  NUMERIC: 'numeric',
  STRING: 'string',
  DATE: 'date',
  DATETIME: 'datetime',
};

export const DEFAULT_BY_COLUMN_TYPE = {
  [COLUMN_TYPES.NUMERIC]: OPERANDS_BY_VALUE.EQUALS,
  [COLUMN_TYPES.DATE]: OPERANDS_BY_VALUE.EQUALS,
  [COLUMN_TYPES.DATETIME]: OPERANDS_BY_VALUE.EQUALS,
  [COLUMN_TYPES.STRING]: OPERANDS_BY_VALUE.IN,
};

export const mapDataType = columnType => {
  switch (columnType.toLowerCase()) {
    case 'string':
      return COLUMN_TYPES.STRING;
    case 'date':
      return COLUMN_TYPES.DATE;
    case 'datetime':
      return COLUMN_TYPES.DATETIME;
    case 'long':
    case 'double':
    case 'numeric':
    case 'decimal':
      return COLUMN_TYPES.NUMERIC;

    default:
      throw Error(`column type "${columnType}" has no matching dataType`);
  }
};

export const FILTER_TYPE = {
  NAME: 'NAME',
  CALENDAR: 'CALENDAR',
  COLUMN_ID: 'COLUMN_ID',
  FORMULA_ID: 'FORMULA_ID',
  CARD_FORMULA_ID: 'CARD_FORMULA_ID',
  FUNCTION_TEMPLATE_ID: 'FUNCTION_TEMPLATE_ID',
  LEGACY: 'LEGACY',
};
